import React, { Component } from 'react'

import './style.css'

const Footer = () => (
 <div className="footer">
    <p>alex.tideman@gmail.com</p>
 </div>
)

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/index.js